import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from '../../../../config/endpoints.config';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class SrcExaminfInputService {
  constructor(private http: HttpClient) { }
  CheckInfo(pPram: any) {
    return this.http.post<any>(EndpointsConfig.examinee.InputInf, JSON.stringify(pPram) );
  }
  GetHTOrgCode(pPram: any) {
    return this.http.post<any>(EndpointsConfig.examinee.GetHTorgCode, JSON.stringify(pPram) );
  }
}
